import React from "react"
import MetaTags from "react-meta-tags"
import { withRouter } from "react-router-dom"
import {
  Container,
} from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

import EcommerceBrandsTable from "./EcommerceBrandsTable"
import "../../../assets/scss/custom.scss"

const EcommerceProducts = props => {
  return (
    <>
      {
        <React.Fragment>
          <div className="page-content">
            <MetaTags>
              <title>Brands | EEFind </title>
            </MetaTags>
            <Container fluid>
              <Breadcrumbs title="Ecommerce" breadcrumbItem="Products" />
              <EcommerceBrandsTable
                queryCondition={null}
                activeFilters={["product_brand", "category", "subcategory", "store", "created_at", "non_mrp"]}
                filterQueryConditions={null}
                showCreateBtn={true}
              />
            </Container>
          </div>
        </React.Fragment>
      }
    </>
  )
}
EcommerceProducts.propTypes = {}
export default withRouter(EcommerceProducts)
